import { __awaiter as e } from "tslib";
import t from "qrcode";
import * as o from "react";
import { Logger as r } from "aws-amplify";
import { translate as a, getTotpCodeURL as i } from "@aws-amplify/ui";
import { Flex as n } from "../../../primitives/Flex/Flex.js";
import { Heading as l } from "../../../primitives/Heading/Heading.js";
import { useAuthenticator as m } from "@aws-amplify/ui-react-core";
import { useCustomComponents as s } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as c } from "../hooks/useFormHandlers/useFormHandlers.js";
import { ConfirmSignInFooter as d } from "../shared/ConfirmSignInFooter.js";
import { RemoteErrorMessage as p } from "../shared/RemoteErrorMessage.js";
import { FormFields as u } from "../shared/FormFields.js";
import { RouteContainer as f } from "../RouteContainer/RouteContainer.js";
const g = new r("SetupTOTP-logger"),
  E = _ref => {
    let {
      className: r,
      variation: l
    } = _ref;
    var h;
    const {
        fields: v,
        getTotpSecretCode: C,
        isPending: y,
        user: H
      } = m(e => [e.isPending]),
      {
        handleChange: w,
        handleSubmit: S
      } = c(),
      {
        components: {
          SetupTOTP: {
            Header: F = E.Header,
            Footer: j = E.Footer
          }
        }
      } = s(),
      [T, x] = o.useState(!0),
      [P, V] = o.useState(),
      [b, O] = o.useState("COPY"),
      [R, k] = o.useState(""),
      {
        totpIssuer: L = "AWSCognito",
        totpUsername: M = null == H ? void 0 : H.username
      } = null !== (h = null == v ? void 0 : v.QR) && void 0 !== h ? h : {},
      q = o.useCallback(() => e(void 0, void 0, void 0, function* () {
        try {
          const e = yield C();
          k(e);
          const o = i(L, M, e),
            r = yield t.toDataURL(o);
          V(r);
        } catch (e) {
          g.error(e);
        } finally {
          x(!1);
        }
      }), [C, L, M]);
    o.useEffect(() => {
      P || q();
    }, [q, P]);
    return o.createElement(f, {
      className: r,
      variation: l
    }, o.createElement("form", {
      "data-amplify-form": "",
      "data-amplify-authenticator-setup-totp": "",
      method: "post",
      onChange: w,
      onSubmit: S
    }, o.createElement(n, {
      as: "fieldset",
      direction: "column",
      isDisabled: y
    }, o.createElement(F, null), o.createElement(n, {
      direction: "column"
    }, T ? o.createElement("p", null, a("Loading"), "…") : o.createElement("img", {
      "data-amplify-qrcode": !0,
      src: P,
      alt: "qr code",
      width: "228",
      height: "228"
    }), o.createElement(n, {
      "data-amplify-copy": !0
    }, o.createElement("div", null, R), o.createElement(n, {
      "data-amplify-copy-svg": !0,
      onClick: () => {
        navigator.clipboard.writeText(R), O(a("COPIED"));
      }
    }, o.createElement("div", {
      "data-amplify-copy-tooltip": !0
    }, b), o.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, o.createElement("path", {
      d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), o.createElement(u, null), o.createElement(p, null)), o.createElement(d, null), o.createElement(j, null))));
  };
E.Header = function () {
  return o.createElement(l, {
    level: 3
  }, a("Setup TOTP"));
}, E.Footer = function () {
  return null;
};
export { E as SetupTOTP };